import { FileOutlined, HomeOutlined, UserOutlined, EllipsisOutlined } from '@ant-design/icons';


// 导入组件
import Home from "@/pages/home";
import Filelist from "@/pages/filelist";
import About from "@/pages/about";
import Privacy from "@/pages/privacy";
import Agreement from "@/pages/agreement";

const routes: Array<any> = [
	{
		label: '首页',
		key: '/home',
		disabled: false,//禁用
		icon: <HomeOutlined />,//图标
		element: <Home />,//组件
	},
	{
		label: '文件',
		key: '/filelist',
		disabled: false,
		icon: <FileOutlined />,
		element: <Filelist />,
	},
	{
		label: '个人',
		key: '/about',
		disabled: false,
		icon: <UserOutlined />,
		element: <About />,
	},
	{
		label: '更多',
		key: '/SubMenu',
		disabled: false,
		icon: <EllipsisOutlined />,
		children: [
			{
				label: '隐私保护指引',
				key: '/privacy',
				disabled: false,
				icon: "",
				element: <Privacy />,
			},
			{
				label: '攻城狮协议',
				key: '/agreement',
				disabled: false,
				icon: "",
				element: <Agreement />,
			},
		],
	},
];

export { routes }